import React from 'react'
import Image from "../../asserts/images/e.png" ;

function Finance() {
  return (
    <div className='contentimagesDirection'>
    <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
              <p>Responsable finance : <br/> Wafa Mezrioui</p>
              <p id='email1'><i class="fa-regular fa-envelope"></i> wafa.mezrioui@gmail.com</p>
            </div>
        </div>
        
       
    </div>
 
  )
}

export default Finance